import { ClearProperty } from 'csstype';

export const aspectContainer = (ratio = 1 /* W / H */) => {
  return {
    '&::before': {
      content: '" "',
      width: '1px',
      marginLeft: '-1px',
      display: 'block',
      paddingTop: `${(1 / ratio) * 100}%`
    },
    '&::after': {
      content: '" "',
      display: 'table',
      clear: 'both' as ClearProperty
    }
  };
};
